export default __webpack_public_path__ + "media/images/images_v2/copyright-fb5a9b005b55433a004f2e2ca533bea0.png";